import { authUser } from '@hub/router/routerAuth';
import type { UserInfo } from '@platform/api';
import React from 'react';
import type { AuthState } from './auth.types';

export const AuthContext = React.createContext<AuthState | null>(null);

export function useAuth(): AuthState {
  const ctx = React.useContext(AuthContext);
  if (!ctx) {
    throw new Error('useAuth must be used within AuthProvider');
  }
  return ctx;
}

/** The signed-in user, or `null` in every other session state. For components that
 *  need the identity but not the distinction between anonymous, loading and unresolved. */
export function useAuthUser(): UserInfo | null {
  return authUser(useAuth());
}
